var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56543 2C10.3068 2 11.9776 2.69151 13.209 3.92285C14.4402 5.15408 15.1317 6.82423 15.1318 8.56543C15.1318 10.0549 14.6239 11.4911 13.707 12.6465L17.7188 16.6592C18.0114 16.9521 18.0116 17.4269 17.7188 17.7197C17.4259 18.0123 16.951 18.0123 16.6582 17.7197L12.6465 13.707C11.4911 14.6239 10.0549 15.1318 8.56543 15.1318C6.82423 15.1317 5.15408 14.4402 3.92285 13.209C2.69151 11.9776 2 10.3068 2 8.56543C2.00012 6.82421 2.69162 5.15409 3.92285 3.92285C5.15409 2.69162 6.82421 2.00012 8.56543 2ZM8.56543 3.5C7.22204 3.50012 5.93333 4.03347 4.9834 4.9834C4.03347 5.93333 3.50012 7.22204 3.5 8.56543C3.5 9.90898 4.03336 11.1984 4.9834 12.1484C5.93332 13.0983 7.22206 13.6317 8.56543 13.6318C9.90369 13.6318 11.1878 13.1022 12.1367 12.1592C12.1404 12.1554 12.1437 12.1512 12.1475 12.1475C12.1512 12.1437 12.1554 12.1404 12.1592 12.1367C13.1022 11.1878 13.6318 9.90369 13.6318 8.56543C13.6317 7.22206 13.0983 5.93333 12.1484 4.9834C11.1984 4.03336 9.90898 3.5 8.56543 3.5Z",
    fill: "#676879"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d9ab9735.svg";
export { ForwardRef as ReactComponent };